<script>
import appConfig from "@/app.config";
export default {
  props: {
    data: Object,
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
    };
  },
  methods: {
    getImgUrl(img) {
      return this.assetsPath + "images/" + img;
    },
  },
};
</script>
<template>
  <div :class="$style.searchCard" class="w-100 d-inline-block">
    <div
      :class="$style.logo"
      v-bind:style="{ backgroundImage: 'url(' + data.logo + ')' }"
    />
    <div class="w-100 d-inline-block" :class="$style.cardBody">
      <h2>{{ data.title }}</h2>
      <p>
        {{ $t("header.searchIn") }}
        <a :href="GLOBAL.hrefLink('games')"> {{ $t("header.searchGames") }}</a>
      </p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.searchCard {
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  border-radius: 14px;
  padding: 25px 25px 25px 0;
  position: relative;
  min-height: 113px;
  .logo {
    position: absolute;
    top: 25px;
    left: 25px;
    width: 64px;
    height: 64px;
    border-radius: 14px;
    background-size: cover;
    background-position: center;
  }
  .cardBody {
    padding-left: 109px;
  }
  h2 {
    font-size: 18px;
    color: #231f20;
    line-height: 1;
    margin-top: 10px;
  }
  p {
    font-size: 16px;
    color: #514f50;
    line-height: 1;
    margin: 0;
    a {
      color: #3b8ede;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>